import { createContext } from 'react';

import { createStore, type Store } from '../../../core/store/store.js';
import type { Point } from '../../core/types/point.js';
import type { GanttSegmentData } from '../types/gantt-chart.js';

/**
 * @internal
 */
export type GanttChartContent = {
  segment: GanttSegmentData;
  row: GanttSegmentData[];
  parent?: GanttSegmentData[];
};

/**
 * @internal
 */
export type GanttChartState = {
  tooltip: {
    pinned: boolean;
    visible: boolean;
    content?: GanttChartContent;
    position?: Point;
  };
  overlay: {
    mouseInBounds: boolean;
  };
};

/**
 * @internal
 */
export const ganttChartStateInitialState: GanttChartState = {
  tooltip: {
    pinned: false,
    visible: false,
  },
  overlay: {
    mouseInBounds: false,
  },
};

/**
 * @internal
 */
export const GanttChartStateContext = createContext<Store<GanttChartState>>(
  createStore<GanttChartState>(ganttChartStateInitialState),
);
